import React, { useState } from "react";
import useApi from "../../hooks/apiService";

const TestPage = () => {
  const [route, setRoute] = useState("");
  const [body, setBody] = useState("");
  const [response, setResponse] = useState("");
  const [loading, setLoading] = useState(false);
  const { postData } = useApi();

  const handleSend = async () => {
    setLoading(true);
    setResponse("");
    try {
      const parsedBody = body ? JSON.parse(body) : {};
      const res = await postData(route, parsedBody);
      setResponse(JSON.stringify(res.data, null, 2));
    } catch (err) {
      setResponse("Erro: " + (err?.response?.data?.message || err.message));
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        maxWidth: 600,
        margin: "40px auto",
        padding: 20,
        border: "1px solid #ccc",
        borderRadius: 8,
      }}
    >
      <h2>Testar API</h2>
      <div style={{ marginBottom: 16 }}>
        <label>Endpoint:</label>
        <input
          type="text"
          value={route}
          onChange={(e) => setRoute(e.target.value)}
          style={{ width: "100%", marginTop: 4, padding: 8 }}
          placeholder="Endpoint"
        />
      </div>
      <div style={{ marginBottom: 16 }}>
        <label>Body da requisição (JSON):</label>
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          style={{ width: "100%", height: 120, marginTop: 4, padding: 8 }}
          placeholder='{"key": "value"}'
        />
      </div>
      <button
        onClick={handleSend}
        disabled={loading}
        style={{ padding: "8px 16px" }}
      >
        {loading ? "Enviando..." : "Enviar"}
      </button>
      <div style={{ marginTop: 24 }}>
        <label>Resposta da API:</label>
        <pre
          style={{
            background: "#f7f7f7",
            padding: 12,
            borderRadius: 4,
            minHeight: 60,
          }}
        >
          {response}
        </pre>
      </div>
    </div>
  );
};

export default TestPage;
